const HeaderSide = (props) => {
  const { logo } = props;
  return (
    <div className="tw-fixed tw-top-0 tw-left-0 lg:tw-h-screen tw-h-25 lg:tw-w-60 tw-w-full lg:tw-p-14 tw-py-4 tw-px-8 lg:tw-border-r tw-border-black/10 tw-bg-white max-lg:tw-border-b">
      <img
        src={logo?.url}
        alt={logo?.alt || logo?.label}
        className="max-lg:!tw-h-full tw-object-contain"
      />
    </div>
  );
};

export default HeaderSide;
